define('common/guid',["require", "exports"], function (require, exports) {
    "use strict";
    var Guid;
    (function (Guid) {
        //Use this only at the client - never for DB PK insterts (replace at server side)
        function generate() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
            });
            return uuid;
        }
        Guid.generate = generate;
    })(Guid || (Guid = {}));
    return Guid;
});

